import { o_global } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const storage = /*           */ asExport(
  o_global,
  "globalStorage",
  noop
);
export {
  storage
};
/*                                       */
